import { AxiosError } from 'axios';
import { IApproveRequest, ICNDNApproval, ICNDNRequest, ICNDNWaybill, ICreditNoteRequest, IDebitNoteRequest, IUpdateCNDNRequest } from '../model/CNDNModel';
import { IPagination } from '../model/CommonModel';
import AjexPortalService from "./api";
import config from './config';
import { getNotificationStyle } from '../common/notification';

const cndnWaybill = config.get('cndnWaybill');
const cnRequest = config.get('cnRequest');
const dnRequest = config.get('dnRequest');
const cnRequestDetails = config.get('cnRequestDetails');
const dnRequestDetails = config.get('dnRequestDetails');
const cnRequestId = config.get('cnRequestId');
const waybillInfo = config.get('waybillInfo');
const page = config.get('page');
const size = config.get('size');
const print = config.get('print');
const approve = config.get('approve');
const approveAll = config.get('approveAll');
const director = config.get('director');
const finance = config.get('finance');
const commonURL = process.env.REACT_APP_TMS_COMMON_SERVICE
const reportURL = process.env.REACT_APP_TMS_REPORT_SERVICE;

export const GetCNWaybillService = async ({ pageNo, pageSize, financeConfirmed, directorConfirmed, divisionHeasdConfirmed, cfoConfirmed }: IPagination) => {
    try {
        return await AjexPortalService.get(`${commonURL}/${cnRequest}/paginated?${page}=${pageNo}&${size}=${pageSize}&isFinanceConfirmed=${financeConfirmed === undefined ? "" : financeConfirmed}&isDirectorConfirmed=${directorConfirmed === undefined ? "" : directorConfirmed}&isDivisionHeadConfirmed=${divisionHeasdConfirmed === undefined ? "" : divisionHeasdConfirmed}&isCfoConfirmed=${cfoConfirmed === undefined ? "" : cfoConfirmed}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const GetConfirmedWaybillService = async ({ pageNo, pageSize, financeConfirmed, directorConfirmed, divisionHeasdConfirmed, cfoConfirmed }: IPagination) => {
    try {
        return await AjexPortalService.get(`${commonURL}/${cnRequest}/paginated?${page}=${pageNo}&${size}=${pageSize}&isFinanceConfirmed=${financeConfirmed === undefined ? "" : financeConfirmed}&isDirectorConfirmed=${directorConfirmed === undefined ? "" : directorConfirmed}&isDivisionHeadConfirmed=${divisionHeasdConfirmed === undefined ? "" : divisionHeasdConfirmed}&isCfoConfirmed=${cfoConfirmed === undefined ? "" : cfoConfirmed}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const GetDNWaybillService = async ({ pageNo, pageSize }: IPagination) => {
    try {
        return await AjexPortalService.get(`${commonURL}/${dnRequest}/paginated?${page}=${pageNo}&${size}=${pageSize}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const GetCNWaybillByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${commonURL}/${cnRequestDetails}/${cnRequestId}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const GetCNDNWaybillHistoryService = async (waybill: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}/${cnRequestDetails}/${waybillInfo}/${waybill}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const GetDebitNoteWaybillHistoryService = async (waybill: string) => {
    try {
        return await AjexPortalService.get(`${commonURL}/${dnRequestDetails}/${waybillInfo}/${waybill}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const GetCNDNWaybillSearchService = async (request: ICNDNWaybill) => {
    try {
        return await AjexPortalService.post(`${commonURL}/${cndnWaybill}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const SaveCNService = async (request: ICreditNoteRequest) => {
    try {
        return await AjexPortalService.post(`${commonURL}/${cnRequest}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
//{{commons}}/api/v1/cn-request
export const SaveCNDNService = async (request: ICNDNRequest) => {
    try {
        return await AjexPortalService.post(`${commonURL}/${cnRequest}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const SaveDebitNoteService = async (request: IDebitNoteRequest) => {
    try {
        return await AjexPortalService.post(`${commonURL}/${dnRequest}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const UpdateCreditDebitNoteService = async ({ id, request }: { id: number, request: IUpdateCNDNRequest }) => {
    try {
        return await AjexPortalService.put(`${commonURL}/${cnRequest}/${id}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const ApproveDebitNoteByIdService = async (request: Partial<Omit<IApproveRequest, 'cnRequestNo'>>) => {

    //https://apps-sit.aj-ex.com/tms-common-service/api/v1/cn-request/approve/34
    try {

        return await AjexPortalService.put(`${commonURL}/${dnRequest}/${approve}/${finance}/${request?.id}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const ApproveDebitNoteAllService = async (request: Partial<Omit<IApproveRequest, 'cnRequestNo'>>) => {

    //https://apps-sit.aj-ex.com/tms-common-service/api/v1/cn-request/approve/34
    try {

        return await AjexPortalService.put(`${commonURL}/${dnRequest}/${approveAll}/${finance}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const DirectorApproveDebitNoteByIdService = async (request: Partial<Omit<IApproveRequest, 'cnRequestNo'>>) => {
    try {

        return await AjexPortalService.put(`${commonURL}/${dnRequest}/${approve}/${director}/${request?.id}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const DirectorApproveDebitNoteAllService = async (request: Partial<Omit<IApproveRequest, 'cnRequestNo'>>) => {
    try {
        return await AjexPortalService.put(`${commonURL}/${dnRequest}/${approveAll}/${director}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const ApproveCreditNoteService = async (request: Partial<Omit<IApproveRequest, 'dnRequestNo'>>) => {
    try {
        return await AjexPortalService.put(`${commonURL}/${cnRequest}/${approve}/${request?.id}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const PrintCreditNoteService = async (id: number | undefined) => {
    try {
        //https://apps-sit.aj-ex.com/tms-common-service//api/v1/cn-request/print/5
        return await AjexPortalService.get(`${commonURL}/${cnRequest}/${print}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const PrintDebitNoteService = async (id: number | undefined) => {
    try {
        //https://apps-sit.aj-ex.com/tms-common-service//api/v1/cn-request/print/5
        return await AjexPortalService.get(`${commonURL}/${dnRequest}/${print}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}
export const GetDNWaybillSearchService = async (userDetails: ICNDNWaybill) => {
    try {
        return await AjexPortalService.post(`${commonURL}/${cndnWaybill}`, userDetails);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
//{{commons}}/api/v1/cn-request/approve-reject-all
export const ApproveByFinanceService = async (request: ICNDNApproval) => {
    try {
        return await AjexPortalService.put(`${commonURL}/${cnRequest}/${approveAll}/finance`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const ApproveByDirectorService = async (request: ICNDNApproval) => {
    try {
        return await AjexPortalService.put(`${commonURL}/${cnRequest}/${approveAll}/director`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const ApproveByDirectorByIdService = async (request: ICNDNApproval) => {
    try {
        return await AjexPortalService.put(`${commonURL}/${cnRequest}/${approveAll}`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const FilterCNWaybillService = async ({ pageNo, pageSize, financeConfirmed, directorConfirmed, customer, industryGroup, waybillNo, divisionHeasdConfirmed, cfoConfirmed, fromDate, toDate , approvalDateType, fromApprovalDate , toApprovalDate}: IPagination) => {    try {
return await AjexPortalService.get(`${commonURL}/${cnRequest}/paginated?${page}=${pageNo}&${size}=${pageSize}&isFinanceConfirmed=${financeConfirmed === undefined ? "" : financeConfirmed}&isDirectorConfirmed=${directorConfirmed === undefined ? "" : directorConfirmed}${customer !== undefined ? '&customer='+customer : ''}${industryGroup !== undefined ? '&industryGroup='+industryGroup : ''}${waybillNo !== undefined ? '&waybillNo='+waybillNo : ''}${fromDate !== undefined ? '&fromDate='+fromDate : ''}${toDate !== undefined ? '&toDate='+toDate : ''}${fromApprovalDate !== undefined ? '&fromApprovalDate='+fromApprovalDate : ''}${toApprovalDate !== undefined ? '&toApprovalDate='+toApprovalDate : ''}${approvalDateType !== undefined ? '&approvalDateType='+approvalDateType : ''}&isDivisionHeadConfirmed=${divisionHeasdConfirmed === undefined ? "" : divisionHeasdConfirmed}&isCfoConfirmed=${cfoConfirmed === undefined ? "" : cfoConfirmed}`);    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const ExportCnDnToExcelService = async ({ pageNo, pageSize, financeConfirmed, directorConfirmed, customer, industryGroup, divisionHeasdConfirmed, cfoConfirmed }: IPagination) => {
    try {
      return await AjexPortalService.get(`${reportURL}report/cn-dn/to-excel?isFinanceConfirmed=${financeConfirmed === undefined ? "" : financeConfirmed}&isDirectorConfirmed=${directorConfirmed === undefined ? "" : directorConfirmed}${customer !== undefined ? '&customer='+customer : ''}${industryGroup !== undefined ? '&industryGroup='+industryGroup : ''}&isDivisionHeadConfirmed=${divisionHeasdConfirmed === undefined ? "" : divisionHeasdConfirmed}&isCfoConfirmed=${cfoConfirmed === undefined ? "" : cfoConfirmed}`);

    } catch (error) {
      const err = error as AxiosError;
      getNotificationStyle(err?.response);
      return err?.response;
    }
  };

  
  export const RePushToOracleService = async (id: number) => {
    try {
        return await AjexPortalService.put(`${commonURL}/cn-request/oracle-push/request-id/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

export const FetchFromOracleService = async (waybillNo: string) => {
    try {
        return await AjexPortalService.post(`${commonURL}manifest/fetch-from-oracle/${waybillNo}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}


export const ApproveByDivisionService = async (request: ICNDNApproval) => {
    try {
        return await AjexPortalService.put(`${commonURL}/${cnRequest}/${approveAll}/division-head`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
export const ApproveByCFOService = async (request: ICNDNApproval) => {
    try {
        return await AjexPortalService.put(`${commonURL}/${cnRequest}/${approveAll}/cfo`, request);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}